import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import i18n from 'utils/i18n'
import ThemedSafeAreaComponentTop from 'components/atoms/ThemedSafeAreaTop'
import ThemedLayout from 'components/atoms/ThemedLayout'
import { useNavigation, useRoute } from '@react-navigation/native'
import Input from "theme/Input";
import Text from "theme/Text";
import BookingFooter from 'scenes/home/book/_components/BookingFooter'
import _ from 'lodash'
import ThemedBlock from 'components/atoms/ThemedBlock'
import { useDispatch, useSelector } from 'react-redux'
import { dataConstants } from 'services/redux/data/constants'
import ObjectBooking from 'utils/objects/booking'
import { cartConstants } from 'services/redux/cart/constants'
import HelperString from 'utils/helper-string'
import { Keyboard, StyleSheet, View } from 'react-native'
import { ThemedValues } from 'styles/themed'
import Timeslot from 'components/molecules/Timeslot'
import TextDivider from 'components/atoms/TextDivider'
import { setCartTimeslotTransportDefaultLicensePlate, setCartTimeslotTransportLicensePlate } from 'services/redux/cart/actions'
import FetchTimeslotCapacity from 'utils/fetch/FetchTimeslotCapacity'
import { AppRoutes } from 'navigations/app-routes'
import LoadingComponent from 'components/atoms/Loading'
import HelperValidate from 'utils/helper-validate'
import { timeslotKindConstants } from 'utils/constants/timeslot-kind-constants'
import { selectCartEmployees, selectCartTimeslotsByKind } from 'services/redux/cart/reducers'
import useRouteParameters from 'utils/hooks/use-route-parameters'
import { TESTID } from '_shared/config/testID'
import { routeBookingConstants } from 'utils/constants/route/RouteBookingConstants'
import { bookingOptions, bookingStatusActive } from 'utils/constants/booking-constants'
import TimeslotDivider from 'components/atoms/TimeslotDivider'
import HelperDate from 'utils/helper-date'
import FetchLicensePlate from 'utils/fetch/FetchLicensePlate'
import { colorList } from 'utils/colors'
import ThemedModal from 'components/atoms/ThemedModal'
import ThemedPressable from 'components/atoms/ThemedPressable'
import VStack from 'components/atoms/stack/VStack'

const HomeBookLicensePlateScene = () => {
	
	const navigation = useNavigation();
	const route = useRoute();
	const dispatch = useDispatch()
	const _routeParameters = useRouteParameters( route );
	
	const [ loading, setLoading ] = useState( true );
	const [ footerHeight, setFooterHeight ] = useState( 0 )
	const [ days, setDays ] = useState( {} );
	const [ timeslotCount, setTimeslotCount ] = useState( 0 );
	
	const [ licensePlatesLoading, setLicensePlatesLoading ] = useState( false );
	const [ licensePlates, setLicensePlates ] = useState( {} );

	const mustValidateLicensePlate = true;
	const [ licensePlatesValid, setLicensePlatesValid ] = useState( {} );
	const licensePlatesValidRef = useRef( {} )
	
	const _bookForOption = _.get( _routeParameters, routeBookingConstants.FOR_OPTION );
	
	const _employee = useSelector( state => {
		return state.data[dataConstants.EMPLOYEE];
	} );
	const _buildings = useSelector( state => {
		return state.data[dataConstants.BUILDINGS];
	} )
	const _floors = useSelector( state => {
		return state.data[dataConstants.FLOORS];
	} )
	const _rooms = useSelector( state => {
		return state.data[dataConstants.ROOMS];
	} )
	const _cartTimeslotsTransport = useSelector( state => {
		return selectCartTimeslotsByKind(state, timeslotKindConstants.TRANSPORT);
	} );
	const _cartEmployees = useSelector( selectCartEmployees );
	const _employeeStatus = useSelector( state => {
		return state.cart[cartConstants.EMPLOYEE_STATUS];
	} );
	
	const _cartTimeslotsTransportDefaultLicensePlate = useSelector( state => {
		return state.cart[cartConstants.TIMESLOTS_TRANSPORT_DEFAULT_LICENSE_PLATE];
	} );
	const _cartTimeslotsTransportLicensePlates = useSelector( state => {
		return state.cart[cartConstants.TIMESLOTS_TRANSPORT_LICENSE_PLATES];
	} );
	
	// Get the default employee license plate OR get the one already set previously
	const defaultLicensePlate = useMemo( () => {
		let result = _.get( _employee, 'license_plate', null );
		if( !HelperValidate.isValid( result ) ) {
			result = _cartTimeslotsTransportDefaultLicensePlate
		}
		
		return FetchLicensePlate.prepareValue( result );
	}, [ _employee, _cartTimeslotsTransportDefaultLicensePlate ] )
	
	const onLicencePlateChange = ( key, employee, value ) => {
		const newLicencePlates = {
			...licensePlates,
			[ key ]: {
				...licensePlates[ key ] ?? {},
				[ employee.guid ]: FetchLicensePlate.prepareValue( value )
			}
		};
		
		setLicensePlates( newLicencePlates )
	}

	const onDefaultLicencePlateChange = ( value ) => {
		value = FetchLicensePlate.prepareValue( value );
		
		dispatch( setCartTimeslotTransportDefaultLicensePlate( value ) );
		
		const newLicencePlates = {};
		_.forEach( _cartTimeslotsTransport, transport => {
			const key = FetchTimeslotCapacity.keyByBooking( transport );
			
			newLicencePlates[ key ] = {
				...licensePlates[ key ] ?? {},
				[ _employee.guid ]: value
			};
		});
		
		setLicensePlates( newLicencePlates )
	}
	
	const getParking = () => {
		return _.filter( _.sortBy( _cartTimeslotsTransport, 'booking_date' ), o => {
			return !ObjectBooking.didAlreadyBook( [ o ] );
		});
	}
	
	const areLicensePlatesValid = () => {
		if( licensePlatesLoading ) {
			return false;
		}
		
		let requiredEmployees = _.map( _cartEmployees, o => {
			return o.guid;
		} );
		let licensePlateSetCount = 0;
		
		// Check if required
		// - The booker is always required
		// - When accepted the employee is also required
		_.map( _cartEmployees, employee => {
			if( employee.guid !== _employee.guid ) {
				const employeeStatus = _.get( _employeeStatus, employee.guid, null );
				
				// No status or not a active one?
				// Remove from the list
				if( employeeStatus === null || !bookingStatusActive.includes( employeeStatus ) ) {
					if( requiredEmployees.includes( employee.guid ) ) {
						requiredEmployees = _.without( requiredEmployees, employee.guid )
					}
				}
			}
		})
		
		// License plate is 6 (or more with - )
		_.forEach( licensePlates, o => {
			
			_.forEach( o, ( licensePlate, guid ) => {
				const licensePlateRequired = requiredEmployees.includes( guid );
				
				// Get the validation record
				const licensePlateValid = _.get( licensePlatesValid, licensePlate, {} );
				
				// Check the values
				const isLicensePlateValid = licensePlateValid.is_valid === 'yes';
				const isLicensePlateLimitsValid = _.isEmpty( licensePlateValid.limitation_errors )
				const isSameLicensePlate = _.countBy( o, o => {
					return o === licensePlate;
				} ).true > 1;
				
				if( licensePlateRequired === true && _.size( licensePlate ) >= 3 && isLicensePlateValid && isLicensePlateLimitsValid && !isSameLicensePlate ) {
					licensePlateSetCount++;
				}
				
				// Not required? remove from the employee list
				if( licensePlateRequired === false ) {
					if( requiredEmployees.includes( guid ) ) {
						requiredEmployees = _.without( requiredEmployees, guid )
					}
				}
			})
		})
		
		// Nothing required? Then always yes
		if( _.size( requiredEmployees ) === 0 ) {
			return true;
		}
		
		// Calc
		const updatedLicensePlateSetCount =  licensePlateSetCount / _.size( requiredEmployees );
		
		// Check
		return ( updatedLicensePlateSetCount >= timeslotCount )
	}
	
	const storeLicensePlates = () => {
		// Set the license plates in validate ref to no if it doe snot exist
		_.forEach( licensePlates, ( o, key ) => {
			_.forEach( o, ( licensePlate, guid ) => {
				if( !_.has( licensePlatesValidRef.current, licensePlate ) ) {
					licensePlatesValidRef.current[ licensePlate ] = {
						is_valid: 'no',
						limitation_errors: [],
						limitation_warnings: [],
					};
				}
			})
		});
		setLicensePlatesValid( licensePlatesValidRef.current )
		
		// Store the license plates
		dispatch( setCartTimeslotTransportLicensePlate( licensePlates ) );
		
		// And check online
		if( mustValidateLicensePlate ) {
			debounceValidateLicensePlatesApi( licensePlates );
		}
	}
	
	const validateLicensePlatesApi = ( licensePlates ) => {
		setLicensePlatesLoading( true )
		
		const values = [];
		_.forEach( licensePlates, ( employees, key ) => {
			const { timeslot } = FetchTimeslotCapacity.extractKeys( key );
			
			_.forEach( employees, ( licensePlate, guid ) => {
				if( !HelperString.isEmptyString( FetchLicensePlate.prepareValue( licensePlate ) ) ) {
					values.push({
						license_plate: licensePlate,
						timeslot_guid: timeslot
					})
				}
			});
		});
		
		FetchLicensePlate.fetchAll( values, {
			callbackStart: () => {
				setLicensePlatesLoading( true )
			},
			callbackSuccess: result => {
				_.forEach( result, licensePlate => {
					licensePlatesValidRef.current[ licensePlate.original_license_plate ] = {
						...licensePlatesValidRef.current[ licensePlate.original_license_plate ],
						is_valid: licensePlate.is_valid,
						limitation_errors: licensePlate.limitation_errors ?? [],
						limitation_warnings: licensePlate.limitation_warnings ?? [],
					};
				});
				
				setLicensePlatesValid({ ...licensePlatesValidRef.current })
				setLicensePlatesLoading( false )
			},
			callbackError: ( error ) => {
				setLicensePlatesLoading( false )
			}
		})
	}
	
	const debounceValidateLicensePlatesApi = useCallback( _.debounce( validateLicensePlatesApi, 600 ), [] )
	
	const onNextPagePress = () => {
		// Extra check to be sure
		if( areLicensePlatesValid() ) {
			// Store again
			storeLicensePlates()
			
			navigation.navigate( AppRoutes.ADD_BOOKING_OVERVIEW, _routeParameters );
		}
	}
	
	useEffect( () => {
		let availableDays = {};
		let newTimeslotCount = 0;

		_.forEach( getParking(), booking => {
			const date = booking.booking_date;

			if( !_.has( availableDays, date ) ) {
				availableDays[ date ] = {};
			}

			const { key, title } = ObjectBooking.extractKeyTitle( booking, {
				_buildings,
				_floors,
				_rooms
			})

			if( !_.has( availableDays[ date ], key ) ) {
				availableDays[ date ][ key ] = {
					title: title,
					data: []
				};
			}

			availableDays[ date ][ key ].data.push( booking );
			newTimeslotCount++;
		});

		setDays( availableDays );
		setTimeslotCount( newTimeslotCount )
	}, [ _cartTimeslotsTransport, _buildings, _rooms, _floors ] );
	
	useEffect( () => {
		return storeLicensePlates();
	}, [ licensePlates ] )
	
	useEffect( () => {
		// Clone the values
		const keys = _.map( _cartTimeslotsTransport, transport => {
			return FetchTimeslotCapacity.keyByBooking(transport);
		} );
		
		const newLicencePlates = {};
		_.forEach( _cartTimeslotsTransportLicensePlates, ( o, k ) => {
			if( keys.includes( k ) ) {
				newLicencePlates[ k ] = { ...o }
			}
		})
		
		// When default is set -> update the new one
		//if( _.isEmpty( licensePlates ) && defaultLicensePlate !== null && isBookForMyself( _bookForOption ) ) {
		if( _.isEmpty( licensePlates ) ) {
			_.forEach( _cartTimeslotsTransport, transport => {
				const key = FetchTimeslotCapacity.keyByBooking( transport )
				
				_.forEach( _cartEmployees, employee => {
					if( !HelperValidate.isValid( _.get( newLicencePlates, [ key, employee.guid ] ) ) ) {
						let defaultLicensePlate = FetchLicensePlate.prepareValue( employee.license_plate );
						
						// Only do this for the current user
						if( !HelperValidate.isValid( defaultLicensePlate ) && _employee.guid === employee.guid ) {
							defaultLicensePlate = _cartTimeslotsTransportDefaultLicensePlate
						}
						
						newLicencePlates[ key ] = {
							...newLicencePlates[ key ],
							[ employee.guid ]: FetchLicensePlate.prepareValue( defaultLicensePlate )
						};
					}
				})
			} );
		}
		
		setLicensePlates( newLicencePlates )
		setLoading( false )
	}, [] )
	
	const timeslotsView =  useMemo( () => {
		return _.map( days, ( buildings, date ) => {
			return _.map( buildings, building => {
				return (
					<View
						key={ HelperString.hash( 'license-plate-timeslot', building ) }>

						<TextDivider
							text={ `${ _.capitalize( HelperDate.date( date ).format( 'dddd - D MMMM' ) ) } - ${ building.title }` }
						/>

						<ThemedBlock
							key={ HelperString.hash( 'day-building', date ) }
							shadow>

							{ _.map( building.data, booking => {
								return (
									<View
										key={ HelperString.hash( `choose-license-render-license-option-view-${date}`, booking.timeslot ) }
										style={ styles.viewMarginBottomMarginHorizontal }>

										<RenderTimeslot
											item={ booking }
											licensePlates={ licensePlates }
											licensePlatesValid={ licensePlatesValid }
											onChange={ onLicencePlateChange }
										/>
									</View>
								);
							}) }
						</ThemedBlock>
					</View>
				);
			});
		});
	}, [ days, licensePlates, licensePlatesValid ] );

	// Check if we can continue
	const canContinue = areLicensePlatesValid()
	
	let content = <LoadingComponent />
	if( !loading ) {
		content = [
			<ThemedBlock
				key={ HelperString.hash( 'license-plate-explanation') }
				mediumPadding
				shadow>
				
				<Text>{ i18n.t('pages.book.license_plate.explanation') }</Text>
			</ThemedBlock>
		]
		
		if( timeslotCount > 1 && _bookForOption === bookingOptions.MYSELF ) {
			content.push(
				<ThemedBlock
					key={ HelperString.hash( 'license-plate-default') }
					mediumPadding
					shadow
					style={ styles.selectAllContainer }>
					
					{/* Intro text */}
					<View style={ styles.viewMarginBottomMarginHorizontal }>
						<Text>{ i18n.t('pages.book.license_plate.multi_option') }</Text>
					</View>
					
					<Input
						testID={ TESTID.HOME.BOOK.LICENSE_PLATE.DEFAULT_LICENSE_PLATE_INPUT }
						placeholder="AA-888-A"
						//defaultValue={ defaultLicensePlate }
						returnKeyType={ "done" }
						onChangeText={ _.debounce( onDefaultLicencePlateChange, 300 ) }
					/>
				</ThemedBlock>
			)
		}
		
		content.push( timeslotsView )
		
		if( _.isEmpty( defaultLicensePlate ) && _bookForOption === bookingOptions.MYSELF ) {
			content.push(
				<ThemedBlock
					key={ HelperString.hash( 'license-plate-default-not-set') }
					mediumPadding
					shadow>
					
					<Text style={ styles.hint }>{ i18n.t('pages.book.license_plate.default_not_set') }</Text>
				</ThemedBlock>
			)
		}
	}
	
	return (
		<ThemedSafeAreaComponentTop
			top={false}>
			
			<ThemedLayout
				contentWidth="narrow"
				title={ i18n.t('titles.book_license_plate') }
				showBackButton={ true }
				topNavigation={ true }
				style={ {
					paddingBottom: footerHeight + 10
				} }>
				
				<VStack space={ ThemedValues.stackSpace }>
					{ content }
				</VStack>
			</ThemedLayout>
			
			<BookingFooter
				onHeight={ setFooterHeight }
				loading={ licensePlatesLoading }
				onPressSubmit={ onNextPagePress }
				disabled={ !canContinue }
				submitLabel={ i18n.t( 'page.create.date.validate_timeslots' ) }
			/>
		</ThemedSafeAreaComponentTop>
	);
}

const RenderTimeslot = ({ item, licensePlates, licensePlatesValid, onChange }) => {
	

	const inputRefs = useRef( {} );

	const _cartEmployees = useSelector( selectCartEmployees );
	
	const [ showModal, setShowModal ] = useState( false );
	
	let optionNr = 0;
	
	const timeTimeslotTime = ObjectBooking.getTimeSlot( item );
	const timeslotKey = FetchTimeslotCapacity.keyByBooking( item )

	useEffect( () => {
		// Overwrite the values when the license plate changes
		_.forEach( inputRefs.current, ( inputRef, index ) => {
			if( inputRef ) {
				const [ timeslotKey, employeeGuid ] = index.split('__');
				const value = licensePlates[ timeslotKey ][ employeeGuid ];
				if( value ) {
					if( inputRef.value !== value ) {
						inputRef.value = value
					}
				}
			}
		})
	}, [ licensePlates ] );
	
	return _.map( _cartEmployees, employee => {
		optionNr++;
		
		const value = _.get( licensePlates, [ timeslotKey, employee.guid ], '' )
		const isLicensePlateSet = !HelperString.isEmptyString( value );
		const licensePlateValid = _.get( licensePlatesValid, value, {} );
		const isSameLicensePlate = _.countBy( licensePlates[ timeslotKey ], o => {
			return o === value;
		} ).true > 1;

		return (
			<View
				key={ HelperString.hash('timeslot-emp', employee, timeslotKey ) }>
				
				<Timeslot
					item={{
						...item,
						employee: employee,
					}}
					withFavourites={ false }
					timeFrom={ _.get( timeTimeslotTime, 0, null ) }
					timeTill={ _.get( timeTimeslotTime, 1, null ) }>
					
					<Input
						ref={ ref => {
							return inputRefs.current[`${timeslotKey}__${employee.guid}`] = ref;
						} }
						testID={ TESTID.HOME.BOOK.LICENSE_PLATE.SINGLE_LICENSE_PLATE_INPUT }
						blurOnSubmit={ false }
						placeholder="AA-888-A"
						defaultValue={ value }
						onChangeText={ onChange.bind( this, timeslotKey, employee ) }
						returnKeyType={ "done" }
						onSubmitEditing={ Keyboard.dismiss }
					/>
					
					{ isLicensePlateSet && (
						<>
						{ (licensePlateValid.is_valid === 'no') && (
							<Text style={ styles.textColorPrimary }>{ i18n.t('pages.book.license_plate.invalid') }</Text>
						)}
						
						{ (licensePlateValid.is_valid === 'yes' && isSameLicensePlate ) && (
							<Text style={ styles.textColorPrimary }>{ i18n.t('pages.book.license_plate.is_same') }</Text>
						)}
						
						{/* Only show the errors when we actually have found the license plate */}
						{ ( licensePlateValid.is_valid === 'yes' && !isSameLicensePlate && !_.isEmpty( licensePlateValid?.limitation_errors ) ) && (
							<ThemedPressable
								onPress={ setShowModal.bind( this, true ) }>
								
								<Text style={ styles.textColorPrimary }>{ i18n.t('pages.book.license_plate.limitation_error' ) }</Text>
							</ThemedPressable>
						)}
						
						{ licensePlateValid.is_valid === 'yes' && !isSameLicensePlate && _.isEmpty( licensePlateValid?.limitation_errors ) && !_.isEmpty( licensePlateValid?.limitation_warnings ) && (
							<Text style={ styles.textColorPrimary2 }>{ i18n.t(`pages.book.license_plate.${ licensePlateValid?.limitation_warnings }` ) }</Text>
						)}
						</>
					)}
				</Timeslot>
			
				{ optionNr < _.size( _cartEmployees ) && (
					<TimeslotDivider />
				)}
				
				<ThemedModal
					visible={ showModal }
					title={ i18n.t('pages.book.license_plate.modal.title' ) }
					setVisible={ setShowModal }>
					
					<VStack
						space={ ThemedValues.stackSpace }>
						
						<Text>{ i18n.t('pages.book.license_plate.modal.text' ) }</Text>
						
						{ _.map( licensePlateValid?.limitation_errors ?? [], ( error, index ) => {
							
							const [ message, allowed, current ] = error.split( '||' );
							
							return (
								<VStack
									key={ HelperString.hash('timeslot-emp-item', employee, timeslotKey ) }>
									
									<Text>{ i18n.t(`pages.book.license_plate.errors.${ message }` ) }:</Text>
									<Text>- { i18n.t(`pages.book.license_plate.errors.current`, { value: current } ) }</Text>
									<Text>- { i18n.t(`pages.book.license_plate.errors.allowed`, { value: allowed } ) }</Text>
								</VStack>
							)
						})}
					</VStack>
				</ThemedModal>
			</View>
		)
	})
}

const styles = StyleSheet.create({
	viewMarginBottomMarginHorizontal: {
		marginBottom: ThemedValues.marginHorizontal,
	},
	textColorPrimary: {
		color: colorList.RED.primary,
	},
	textColorPrimary2: {
		color: colorList.ORANGE.primary,
	},
	hint: {
		fontSize: 14,
		fontStyle: 'italic'
	}
})

export default HomeBookLicensePlateScene;
